// extracted by mini-css-extract-plugin
export const container = "modal-module--container--2L0Rq";
export const close = "modal-module--close--1iZiX";
export const isOpen = "modal-module--isOpen--3AUez";
export const innerContainer = "modal-module--innerContainer--4J3iY";
export const addTiming = "modal-module--addTiming--1nCeZ";
export const dateInnerContainer = "modal-module--dateInnerContainer--1Pq1v";
export const innerCalendarContainer = "modal-module--innerCalendarContainer--BX15p";
export const timeBox = "modal-module--timeBox--1o-IZ";
export const serviceInnerContainer = "modal-module--serviceInnerContainer--3gUlN";
export const shadow = "modal-module--shadow--HhGiy";
export const mapInputContainer = "modal-module--mapInputContainer--AfktY";
export const deliveryAddress = "modal-module--deliveryAddress--2FPvx";
export const deliveryNotes = "modal-module--deliveryNotes--mtidd";
export const mapContainer = "modal-module--mapContainer--hNEQO";
export const checkBoxContainer = "modal-module--checkBoxContainer--lruo6";